import { MarginMap } from "#internal"
import type { Margins } from "#public"
import type { Measure } from "#public"

import { Total } from "../math/Operations"

/**
 * Add two sets of margins edge by edge — what a box reaches when it carries
 * both, such as a page's own padding plus the share of the sheet around it.
 *
 * Not to be confused with {@link AddMargins}, which grows a rect by one set.
 */
export const SumMargins = <T extends Measure>(a: T | Margins<T>, b: T | Margins<T>): Margins<T> =>
  MarginMap(Total, a, b)
